import { Plus, Trash2 } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function RoomsStep({ rooms, setRooms, roomTypes, aiInfo }) {
  const update = (i, patch) => setRooms(rooms.map((r, j) => (j === i ? { ...r, ...patch } : r)));
  const add = () => setRooms([...rooms, { name: "Living Room", type: "living", area_sqft: roomTypes.living.default_area, included: true }]);
  const totalArea = rooms.filter((r) => r.included).reduce((s, r) => s + (Number(r.area_sqft) || 0), 0);

  return (
    <div data-testid="rooms-step">
      {aiInfo && (
        <div className="rounded-2xl bg-brand-ink-soft text-brand-cream p-6 mb-6 flex flex-wrap gap-8 items-center" data-testid="ai-summary-banner">
          <div><p className="text-xs text-brand-muted-light uppercase tracking-[0.2em]">AI detected</p><p className="font-serif-display text-3xl">{aiInfo.bhk || `${rooms.length} rooms`}</p></div>
          <p className="text-sm text-brand-line flex-1 min-w-[220px]">{aiInfo.summary}</p>
        </div>
      )}
      <div className="flex items-end justify-between mb-4">
        <p className="text-sm text-brand-muted">Review & adjust rooms. Toggle off any room you don't want designed (room-wise package).</p>
        <p className="text-sm text-brand-ink whitespace-nowrap" data-testid="rooms-total-area"><span className="font-mono-num">{Math.round(totalArea)}</span> sq.ft</p>
      </div>
      <div className="space-y-3">
        {rooms.map((r, i) => (
          <div key={i} data-testid={`room-row-${i}`} className={`grid grid-cols-12 gap-3 items-center rounded-xl border p-3 md:p-4 transition-opacity ${r.included ? "bg-brand-cream border-brand-line" : "bg-brand-sand border-transparent opacity-60"}`}>
            <Switch checked={r.included} onCheckedChange={(v) => update(i, { included: v })} className="col-span-2 md:col-span-1 data-[state=checked]:bg-brand-accent" data-testid={`room-include-${i}`} />
            <input value={r.name} onChange={(e) => update(i, { name: e.target.value })} data-testid={`room-name-${i}`}
              className="col-span-10 md:col-span-4 bg-transparent border-b border-transparent focus:border-brand-accent outline-none py-1 text-brand-ink" />
            <div className="col-span-7 md:col-span-4">
              <Select value={r.type} onValueChange={(v) => update(i, { type: v })}>
                <SelectTrigger className="bg-white border-brand-line" data-testid={`room-type-${i}`}><SelectValue /></SelectTrigger>
                <SelectContent>{Object.entries(roomTypes).map(([k, v]) => <SelectItem key={k} value={k}>{v.label}</SelectItem>)}</SelectContent>
              </Select>
            </div>
            <div className="col-span-4 md:col-span-2 flex items-center gap-1">
              <input type="number" min="1" value={r.area_sqft} onChange={(e) => update(i, { area_sqft: e.target.value })} data-testid={`room-area-${i}`}
                className="w-full font-mono-num rounded-md border border-brand-line bg-white px-2 py-2 text-sm outline-none focus:border-brand-accent" />
              <span className="text-xs text-brand-muted-light">ft²</span>
            </div>
            <button onClick={() => setRooms(rooms.filter((_, j) => j !== i))} className="col-span-1 text-brand-muted-light hover:text-red-700 justify-self-end" data-testid={`room-delete-${i}`} aria-label="Remove room">
              <Trash2 className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>
      <button onClick={add} className="mt-4 inline-flex items-center gap-2 text-sm text-brand-accent hover:text-brand-accent-dark" data-testid="add-room-btn"><Plus className="w-4 h-4" /> Add room</button>
    </div>
  );
}
